// vehicleSearchSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface searchParams {
  pickupLocation: {
    lat: number;
    lng: number;
    loc: string;
  };
  pickupDate: string;
  pickupTime: string;
  returnDate: string;
  returnTime: string;
}

interface VehicleSearchState {
  hasSearched: boolean;
  searchParams: searchParams | null;
}

const initialState: VehicleSearchState = {
  hasSearched: false,
  searchParams: null,
};

const vehicleSearchSlice = createSlice({
  name: "vehicleSearch",
  initialState,
  reducers: {
    setHasSearched: (state, action: PayloadAction<boolean>) => {
      state.hasSearched = action.payload;
    },
    setSearchParams: (state, action: PayloadAction<searchParams>) => {
      state.searchParams = action.payload;
    },
    clearSearchParams: (state) => {
      state.searchParams = null;
    },
  },
});

export const { setHasSearched, setSearchParams, clearSearchParams } =
  vehicleSearchSlice.actions;
export default vehicleSearchSlice.reducer;
